import {
  fetchSettingsInsight,
  updateSettingsInsight,
  deleteSelectedPlan,
  updateSelectedPlan,
} from "./settingsNetworkAPI";
import { adjustStateAfterSuccessfulDeletion } from "./SettingsUtil";

export const SettingsReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_VIEW":
      const dispatcher = action.data.dispatcher;
      fetchSettingsInsight(dispatcher);
      return state;

    case "SETTINGS_INSIGHT":
      return { ...state, ...action.data };

    case "UPDATE_SETTINGS_INSIGHT":
      updateSettingsInsight(state);
      return state;

    case "UPDATE_PLAN":
      updateSelectedPlan(
        state,
        action.data.dispatcher,
        action.data.planData,
        action.data.shiftTimeRange,
      );
      return state;

    case "UPDATE_PLAN_RESPONSE":
      return {
        ...state,
        showUpdatePlanResponseModal: action.data.showUpdatePlanResponseModal,
        messageToDisplay: action.data.message,
      };

    case "SHOW_UPDATE_PLAN_RESPONSE_MODAL":
      return {
        ...state,
        showUpdatePlanResponseModal: action.modalState,
      };

    case "DELETE_PLAN":
      deleteSelectedPlan(action.data.dispatcher, action.data.planData);
      return state;

    case "DELETE_PLAN_RESPONSE":
      return {
        ...adjustStateAfterSuccessfulDeletion(
          state,
          action.data.plan,
          action.data.showDeletePlanResponseModal,
        ),
        showDeletePlanResponseModal: action.data.showDeletePlanResponseModal,
        messageToDisplay: action.data.message,
      };

    case "SHOW_DELETE_PLAN_RESPONSE_MODAL":
      return {
        ...state,
        showDeletePlanResponseModal: action.modalState,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/settings/SettingsReducer.js